'use strict';

(function () {
	angular
	.module('commons')
	.component('slideInMainMenu', {
		templateUrl: 'commons/components/new-slide-in-main-menu-component.tpl.html',
		controller: function ($timeout, $scope, TabService,applicationConstants, CommonMasterData ,$window,MessageService) {
			var vm = this;

			vm.mainMenus = [];
			vm.isRptPriviledgeLoad = false;
			vm.clickedMenu = '';
			vm.clickedSubMenu= '';
			vm.priviledgeList = {};

			//redirect to selected report page
			vm.onMenuClick = function (path) {
        if(path == 'aeroOps'){
          navigateToAeroOps();
          return;
        }

        if(path === 'newRosters'){
          navigateToNewRostersScreen();
          return;
        }

        if(path === 'alvBiddingReview'){
          navigateToALVBiddingReviewScreen();
          return;
        }

        if(path === 'alvGroupConfiguration'){
          navigateToALVGroupConfiguration();
          return;
        }

        if(path === 'alvSlotPeriodManagement'){
          navigateToALVSlotPeriodManagement();
          return;
        }

        if(path === 'alvBiddingPeriodManagement'){
          navigateToALVBiddingPeriodManagement();
          return;
        }

        if(path === 'alvRuleConfiguration'){
          navigateToALVRuleConfiguration();
          return;
        }

        if (path === 'newRenewals') {
          navigateToNewRenewalsScreen();
          return;
        }

        if (path === 'flightSync') {
          navigateToFlightSyncScreen();
          return;
        }

        if (path === 'trainingSync') {
          navigateToTrainingSyncScreen();
          return;
        }

        if (path === 'ComplianceWatch'){
          navigateToRegulationWarningReportScreen();
          return;
        }

        if(path === 'airportAttribute'){
          console.log('airportAttribute');
          navigateToAirportAttributeScreen();
          return;
        }

        if(path === 'dutyWatch'){
          navigateToDutyWatchScreen();
          return;
        }

        if(path === 'multiGridStats'){
          navigateToMultiGridStatsScreen();
          return;
        }

        if(path === 'crewTargetHours'){
          navigateToCrewTargetHoursScreen();
          return;
        }

        if(path === 'trainingStages'){
          navigateToTrainingStagesScreen();
          return;
        }

        if(path === 'multiGridRosters'){
          navigateToMultiGridRostersScreen();
          return;
        }

        if(path === 'manageCrewAttributes'){
          console.log('manageCrewAttributes');
          navigateToManageCrewAttributesScreen();
          return;
        }


        if(path === 'minimumRestTrainingConfiguration'){
          navigateToMinimumRestTrainingConfigurationScreen();
          return;
        }

        if(path === ''){}

        if(path === ''){}

				vm.loadMenus();
				if(path){
					vm.clickedMenu = '';
					vm.clickedSubMenu= '';
					$( "ul" ).scrollTop( 0 );
					TabService.gotoTab(path);
				}
			};

			//open / close the menu bar level 1 list
			vm.showSubMenu1= function (clickedMenu){
				vm.loadMenus();
				vm.clickedSubMenu= '';

				$( "ul" ).scrollTop( 0 );

				if(vm.clickedMenu == clickedMenu)
					vm.clickedMenu = '';
				else
					vm.clickedMenu = clickedMenu;
			}

			//show all menu bar level 2 list
			vm.showSubMenu2= function (clickedSubMenu){
				vm.loadMenus();
				$( "ul" ).scrollTop( 0 );
				vm.clickedSubMenu = clickedSubMenu;
			}

			//redirect to menu bar level 1 from menu bar level 2
			vm.onBackArrowClick= function (clickedMenu){
				vm.loadMenus();
				vm.clickedSubMenu= '';
				$( "ul" ).scrollTop( 0 );
				vm.clickedMenu = clickedMenu;
			}

			vm.loadMenus = function(){
				if(!vm.isRptPriviledgeLoad){
					CommonMasterData.loadMenu(function(menus) {
						vm.mainMenus = menus;
						vm.isRptPriviledgeLoad = true;
					}, function(error) {
					console.log('Menu Loading error!!!');
					});
				}
			};

      function navigateToAeroOps(){

        CommonMasterData.getAccessDataToAeroOps(function(data) {
          $window.open(data.cookieServiceUrl+'?token='+data.accessToken+'&targetURL='+ data.aeroOpsUrl);

        }, function(error) {
            MessageService.error(error);
        });

      }

      function navigateToNewRostersScreen() {
        console.log("navigateToNewRostersScreen");
        $window.open(window.location.origin + "/react/#/crew/rosters");
      }
      function navigateToALVBiddingReviewScreen() {
        console.log("navigateToALVBiddingReviewScreen");
        $window.open(window.location.origin + "/react/#/alv/annualLeaveReview");
      }
      function navigateToALVGroupConfiguration() {
        console.log("navigateToALVGroupConfiguration");
        $window.open(window.location.origin + "/react/#/alv/annualLeaveGroupConfiguration");
      }
      function navigateToALVSlotPeriodManagement() {
        console.log("navigateToALVSlotPeriodManagement");
        $window.open(window.location.origin + "/react/#/alv/annualLeaveSlotPeriodManagement");
      }
      function navigateToALVBiddingPeriodManagement() {
        console.log("navigateToALVBiddingPeriodManagement");
        $window.open(window.location.origin + "/react/#/alv/annualLeaveBiddingPeriodManagement");
      }
      function navigateToALVRuleConfiguration() {
        console.log("navigateToALVRuleConfiguration");
        $window.open(window.location.origin + "/react/#/alv/annualLeaveRuleConfiguration");
      }

      function navigateToNewRenewalsScreen() {
        console.log("navigateToNewRenewalsScreen");
        $window.open(window.location.origin + "/react/#/training/renewals");
      }

      function navigateToFlightSyncScreen() {
        console.log("navigateToFlightSyncScreen");
        $window.open(window.location.origin + "/react/#/flights/flightSync");
      }

      function navigateToTrainingSyncScreen() {
        console.log("navigateToTrainingSyncScreen");
        $window.open(window.location.origin + "/react/#/training/trainingSync");
      }

      function navigateToRegulationWarningReportScreen() {
        console.log("navigateToRegulationWarningReportScreen");
        $window.open(window.location.origin + "/react/#/crew/complianceWatch");
      }
      function navigateToAirportAttributeScreen() {
        console.log("navigateToALVBiddingReviewScreen");
        $window.open(window.location.origin + "/react/#/settings/airportAttribute");
      }
      function navigateToMultiGridStatsScreen() {
        $window.open(window.location.origin + "/react/#/crew/multiGrid");
      }

      function navigateToDutyWatchScreen() {
        console.log("navigateToDutyWatchScreen");
        $window.open(window.location.origin + "/react/#/crew/dutyWatch");
      }

      function navigateToCrewTargetHoursScreen() {
        $window.open(window.location.origin + "/react/#/crew/crewTargetHours");
      }


      function navigateToTrainingStagesScreen() {
        $window.open(window.location.origin + "/react/#/training/trainingStages");
      }

      function navigateToMultiGridRostersScreen() {
        $window.open(window.location.origin + "/react/#/autoRoster/multiGridRosters");
      }
      function navigateToManageCrewAttributesScreen() {
        console.log("navigateToManageCrewAttributesScreen");
        $window.open(window.location.origin + "/react/#/crew/manageCrewAttributes");
      }

      function navigateToMinimumRestTrainingConfigurationScreen() {
        $window.open(window.location.origin + "/react/#/training/minimumRestTrainingConfiguration");
      }

      (function(){
				vm.loadMenus();
			})();
		},
		bindings: {
			selectedMenuOption : '='
		}
	});
})();
